module.exports = __webpack_public_path__ + "img/menu-hetong.455faa29.svg";